import { render, staticRenderFns } from "./data-table-filter-item.vue?vue&type=template&id=24f83b27&scoped=true&lang=pug&"
import script from "./data-table-filter-item.vue?vue&type=script&lang=ts&"
export * from "./data-table-filter-item.vue?vue&type=script&lang=ts&"
import style0 from "./data-table-filter-item.vue?vue&type=style&index=0&id=24f83b27&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f83b27",
  null
  
)

export default component.exports